import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { UserSimple } from './../../overrides/model/UserSimple.js';
import { ReportSimple } from './../../overrides/model/ReportSimple.js';
import { ProjectSimple } from './../../overrides/model/ProjectSimple.js';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __UserGroup extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  @Type(() => UserSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly users!: (UserSimple)[];
  @Type(() => ReportSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly whispers!: (ReportSimple)[];
  @Type(() => ProjectSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly projects!: (ProjectSimple)[];
  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}
export type UserGroup = Omit<__UserGroup, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'created_at' | 'updated_at'>
export const UserGroup = __UserGroup as any as Constructor<UserGroup>
